import { jFileLittle, WidgetQuickSurveyContent, WidgetQuickSurveyContentArr } from 'jamespot-user-api';
import React, { RefObject, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { Utils } from '../../..';
import { BETA_JRCDragAndDrop } from '../../Beta/BETA_JRCDragAndDrop/BETA_JRCDragAndDrop';
import { ColumnWithDraggable, FormItemContainer } from './JRCWidgetQuickSurveyEditor.styles';
import { JRCWidgetQuickSurveyEditorAddEntry } from './JRCWidgetQuickSurveyEditorAddEntry';
import { JRCWidgetQuickSurveyWrapperItem } from './JRCWidgetQuickSurveyItemWrapper';

export const JRCWidgetQuickSurveyEditorEntries = ({
    content,
    token,
    handleChange,
}: {
    content: WidgetQuickSurveyContent;
    token: string;
    handleChange: (content: Partial<WidgetQuickSurveyContent>) => void;
}) => {
    const intl = useIntl();
    const [lastInputIndex, setLastInputIndex] = useState(0); // State to hold the index of the last input
    const inputRefs = useRef<RefObject<HTMLInputElement>[]>([]); // Ref to hold all input refs
    const length = useMemo<number>(() => (!Array.isArray(content.arr) ? 0 : content.arr.length), [content.arr]);

    const title = intl.formatMessage({ id: 'FIELDS_Add_Option' });

    useEffect(() => {
        if (inputRefs.current[lastInputIndex]?.current) {
            inputRefs.current[lastInputIndex].current?.focus();
        }
    }, [lastInputIndex]);

    const handleItemChange = (idx: number, data: WidgetQuickSurveyContentArr) => {
        if (!Array.isArray(content.arr)) return;

        const arrToChange = content.arr.map((entry, index) => (index === idx ? { ...entry, ...data } : entry));

        handleChange({ ...content, arr: arrToChange });
        setLastInputIndex(arrToChange.length);
    };

    const handleRemoveItem = (idx: number) => {
        if (!Array.isArray(content.arr)) return;

        const tmp = [...content.arr];

        tmp.splice(idx, 1);

        handleChange({ ...content, arr: tmp });
    };

    const handleAddNewImage = (idx: number, file: jFileLittle) => {
        if (!Array.isArray(content.arr)) return;

        const arrToChange = content.arr.map((entry, index) =>
            index === idx ? { ...entry, id: file.id, file } : entry,
        );

        handleChange({ ...content, arr: arrToChange });
    };

    const handleRemoveImage = (idx: number) => {
        if (!Array.isArray(content.arr)) return;

        const arrToChange = content.arr.map((entry, index) => {
            if (index === idx) {
                const tmp = { ...entry };
                delete tmp.file;
                delete tmp.id;
                return tmp;
            } else {
                return entry;
            }
        });

        handleChange({ ...content, arr: arrToChange });
    };

    const handleNewItem = () => {
        if (!Array.isArray(content.arr)) return;
        handleChange({ ...content, arr: [...content.arr, { title }] });
        setLastInputIndex(content.arr.length);
        inputRefs.current.push(React.createRef<HTMLInputElement>());
    };

    if (!Array.isArray(content.arr)) return <></>;

    return (
        <>
            <FormItemContainer border={true}>
                <ColumnWithDraggable>
                    <BETA_JRCDragAndDrop
                        onDrag={(dragIndex, hoverIndex) => {
                            if (content.arr === undefined) return;
                            const arrToChange = Utils.array.arraySwapElements(content.arr, dragIndex, hoverIndex);
                            handleChange({ ...content, arr: arrToChange });
                        }}
                        elms={content.arr}
                        renderEl={(item: WidgetQuickSurveyContentArr, index: number) => {
                            return (
                                <JRCWidgetQuickSurveyWrapperItem
                                    token={token}
                                    key={index}
                                    index={index}
                                    item={item}
                                    setItems={handleItemChange}
                                    removeItem={handleRemoveItem}
                                    handleAddImageWidget={handleAddNewImage}
                                    handleRemoveImage={handleRemoveImage}
                                    handleNewItem={handleNewItem}
                                    length={length}
                                    inputRef={inputRefs.current[index]}
                                />
                            );
                        }}
                    />
                </ColumnWithDraggable>
            </FormItemContainer>
            <JRCWidgetQuickSurveyEditorAddEntry content={content} handleNewItem={handleNewItem} />
        </>
    );
};
